const Mock = require('mockjs');
//格式： Mock.mock( url, post/get , 返回的数据);

//User
Mock.mock('/api/User/GetPermission', 'post', require('./json/user/get_permission'));
Mock.mock('/api/User/Login', 'post', require('./json/user/login'));
Mock.mock('/api/User/Logout', 'post', require('./json/user/logout'));
Mock.mock('/api/User/RefreshToken', 'post', require('./json/user/refreshToken'));
Mock.mock('/api/User/List', 'post', require('./json/user/list'));
Mock.mock('/api/User/Save', 'post', require('./json/user/save'));

//Role
Mock.mock('/api/Role/List', 'post', require('./json/role/list'));
Mock.mock(RegExp('/api/Role/GetRoleWithMenu' + ".*"), 'get', require('./json/role/getRoleWithMenu'));
Mock.mock('/api/Role/Save', 'post', require('./json/role/save'));


//待发货订单
// Mock.mock(RegExp('/api/pdd/orders' + '.*'), 'get', require('./json/pdd/list'));
